<template>
  <inner
    @apply="applySort"
    @clear="clear"
  >
    <mobile-multiselect-item
      v-for="option in options"
      :key="option.value"
      :title="option.name"
      :is-selected="isSelected(option.value)"
      @click.native="select(option.value)"
    />
  </inner>
</template>

<script>
import MobileMultiselectItem from '@/components/mobile-multiselect/mobile-multiselect-item.vue';
import Inner from '@/components/mobile-multiselect/inner.vue';

import {
  DEFAULT_SORT,
} from '@/store/consts';

import categorySortMixin from '@/components/category-sort/category-sort-mixin';

export default {

  components: { MobileMultiselectItem, Inner },

  mixins: [categorySortMixin],

  data() {
    return {
      localValue: null
    };
  },

  mounted() {
    this.localValue = this.value;
  },

  methods: {
    isSelected(optionValue) {
      return optionValue === this.localValue;
    },
    select(optionValue) {
      this.localValue = optionValue;
    },
    applySort() {
      this.$emit('apply', this.localValue);
    },
    clear() {
      this.localValue = DEFAULT_SORT;
    }
  },
}
</script>

